import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Megszűnt",
  "Spare part list": "Pótalkatrészek listája",
  "Download Excel": "Excel letöltése",
  "Recent search list": "Legutóbbi keresések listája",
  "No data": "Nincs adat",
  "spare part": "pótalkatrész",
  "none": "nincs",
  "no value": "nincs érték",
  "No results found": "Nincs eredmény",
  "Spare parts for": "Pótalkatrészek a következőkhöz",
  "Could not load cumulated data": "Nem sikerült betölteni a kumulált adatokat",
  "commissioning part": "üzembe helyezési rész",
  "wear part": "kopó alkatrész",
  "Search": "Keresés",
  "Tk": "Tk",
  "Spare part number": "Pótalkatrész száma",
  "drawing": "rajzolás",
  "Products for": "Termékek a",
  "Available": "Elérhető",
  "MM": "MM",
  "The entered order code is invalid": "A megadott rendelési kód érvénytelen",
  "Recommended": "Ajánlott",
  "No data available for the entered search parameters": "A megadott keresési paraméterekhez nem állnak rendelkezésre adatok",
  "Search spare parts": "Pótalkatrészek keresése",
  "Order code / product root / serial number": "Megrendelési kód / termékgyökér / sorozatszám",
  "Characteristic": "Jellemző",
  "Please enter an order code": "Kérjük, adja meg a rendelési kódot",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "A minőség és biztonság szempontjából az Endress+Hauser határozottan ajánlja, hogy kizárólag eredeti Endress+Hauser pótalkatrészeket használjon. \nA készüléket csak szakképzett személyzet karbantarthatja és javíthatja. \nA készülék dokumentációjára vonatkozó szabványokat és jogi követelményeket, valamint az esetleges tanúsítványokat be kell tartani!",
  "Maintenance advice": "Karbantartási tanácsadás",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Melyik termék(ek)hez használható a pótalkatrészem? A pótalkatrész rendelési kódjának (pl. 71002865 vagy XPD0024) megadása megmutatja, hogy az adott pótalkatrész mely készülékekben használható.",
  "tool": "szerszám",
  "Production numbers": "Gyártási számok",
  "New alternative": "Új alternatíva",
  "There are no items selected. Please use the checkboxes to make your selection": "Nincsenek kijelölt elemek. Kérjük, használja a jelölőnégyzeteket a kiválasztáshoz.",
  "Service segmentation": "Szolgáltatási szegmentáció",
  "Seg": "Seg",
  "Valid": "Érvényes",
  "Pos": "Pos",
  "Value": "Érték",
  "service segmentation 2": "Alapvető ismereteket igénylő részek. Az E+H alapképzésen való sikeres részvétel előfeltétel.",
  "Phase out date": "A kivonás időpontja",
  "service segmentation 1": "Alapvető ismereteket igénylő részek.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Milyen pótalkatrészek állnak rendelkezésre a termékemhez? A rendelési kód (pl. FTC260-AA2A1 vagy PMC51-BA21JB1CGBTDJB) vagy a termék azonosítójának (pl. FTC260 vagy 83F50) megadása után a megfelelő pótalkatrészek megjelennek.",
  "Set filter": "Szűrő beállítása",
  "Search date": "Keresés dátuma",
  "Group": "Csoport",
  "Warning": "Figyelmeztetés",
  "Description": "Leírás",
  "Cancel": "Törölje",
  "service segmentation 4": "Alkatrészek a gyári javításhoz. A szakértői tudás kötelező.",
  "service segmentation 3": "Speciális tudást igénylő részek. Az E+H továbbképzésen való sikeres részvétel előfeltétele.",
  "Drawing Position Number": "Rajz pozíció száma",
  "Spare parts search": "Pótalkatrész keresés",
  "Confirm": "Megerősítés",
  "Ordercode too short": "Túl rövid rendelési kód",
  "Product status": "A termék állapota",
  "Open": "Nyissa meg a  címet.",
  "Clear": "Tiszta",
  "PDF file with assembly instructions": "PDF fájl összeszerelési utasításokkal",
  "Search products": "Keresés termékek",
  "Export": "Exportálás",
  "Production date": "Gyártás dátuma",
  "Order stop": "Rendelés leállítása",
  "Calibration until": "Kalibrálás, amíg",
  "PDF file with compatibility information": "PDF fájl a kompatibilitási információkkal",
  "Add selection to cart": "Válogatás hozzáadása a kosárhoz",
  "Mounting advices": "Szerelési tanácsok",
  "Recommended parts only": "Csak ajánlott alkatrészek",
  "not applicable": "nem alkalmazható",
  "accessories": "tartozékok",
  "Cumulative spare parts list": "Összesített pótalkatrész-lista",
  "YYYY": "YYYY",
  "Title": "Cím",
  "Error": "Hiba",
  "Ordercode too long": "Túl hosszú a rendelési kód",
  "Functions": "Funkciók",
  "Rec": "Rec",
  "Type": "Típus",
  "Spare sensor until": "Tartalék érzékelő, amíg",
  "Spare parts until": "Pótalkatrészek, amíg",
  "Filter": "Szűrő",
  "Check all": "Ellenőrizze az összeset",
  "Order code": "Megrendelés kódja",
  "Repair until": "Javítás, amíg",
  "Tag": "Címke",
  "Ok": "Oké",
  "Category code": "Kategória kód",
  "Phase out": "Lépjen ki",
  'Compatibility advices': 'Kiegészítő dokumentumok',
  'Co.': 'Kieg. dok.',
} as LocalizedDictionary;
